import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import SignaturePad from 'signature_pad';
import {PortalUrlService} from 'src/app/services/portal-url.service/portal-url.service';
import {EstimateStatusTypes} from 'src/app/shared/enums/estimate/estimate.enum';
import {UpdatePortalEstimateDTO} from 'src/app/shared/interfaces/estimate/estimate.interface';
import {PortalUrlContentDetailsModal} from 'src/app/shared/modals/portal-url-content-details.modal';
import {AlertService} from '../../services/alert-service.service';
import {EstimateEntityDTO} from "../../shared/modals/estimate.modal";

@Component({
  selector: 'projul-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit {
  signatureForm: FormGroup = new FormGroup({
    FullName: new FormControl('', Validators.required),
    Reason: new FormControl(''),
    Status: new FormControl(EstimateStatusTypes.Approved)
  })

  @ViewChild('sPad', {static: true}) signaturePadElement: any;
  @Input() portalEstimate: PortalUrlContentDetailsModal;
  @Input() estimate: EstimateEntityDTO;
  @Output() formSubmitBody: EventEmitter<UpdatePortalEstimateDTO> = new EventEmitter<UpdatePortalEstimateDTO>(); // close add edit sidebar panel
  @Input() showAcceptAndSign: boolean = false;

  signaturePad: SignaturePad;
  todayDate = new Intl.DateTimeFormat("en-US", {month: "short", day: "numeric", year: "numeric"}).format(new Date());
  typeText = '';
  dataURL: string = '';
  nameError: boolean = false;
  signatureError: boolean = false;

  minimumPixelsRequired: number = 20;
  maximumPixelsRequired: number = 350;
  signatureNotValid: boolean = false;


  constructor(private portalUrlService: PortalUrlService, private alertService: AlertService) {
  }

  ngOnInit(): void {
  }


  get f() {
    return this.signatureForm?.controls;
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  isSignatureValid(): boolean {
    const signatureData = this.signaturePad.toData();
    let pixelsCount = 0;

    // Loop through signature data and count pixels
    for (const stroke of signatureData) {
      for (const point of stroke.points) {
        if (point.time) {
          pixelsCount++;
        }
      }
    }
    
    return pixelsCount >= this.minimumPixelsRequired && pixelsCount <= this.maximumPixelsRequired;
  }

  clear() {
    this.signaturePad.clear();
  }

  undo() {
    const data = this.signaturePad.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.signaturePad.fromData(data);
    }
  }


  saveSVG() {
    if (this.signaturePad.isEmpty()) {
      this.signatureError = true;
      return false;
    } else {
      return this.dataURL = this.signaturePad.toDataURL('image/svg+xml');

    }
  }

  async submitData() {

    
    if(!this.isSignatureValid()){
      this.signatureNotValid = true;
      this.clear();
    }
    else{
      this.signatureNotValid = false;
      Object.keys(this.signatureForm?.controls).forEach((key) => {
        this.signatureForm?.controls[key].markAsDirty();
      });
      if (this.signatureForm.invalid) {
        this.nameError = true;
        return
      }
      let response = this.saveSVG();
      if (!response) {
        return
      }
  
      let formValue = this.signatureForm.value as UpdatePortalEstimateDTO;
      formValue.PortalUrlId = this.portalEstimate.UrlId;
      formValue.EstimateDetailsId = this.estimate.EstimateDetails[0].Id;
      formValue.Reason = this.dataURL;
      formValue.EstimateAmount = this.estimate.EstimateValues?.TotalWithTax - (this.estimate.EstimateValues?.TotalDiscount || 0);
      formValue.CustomerName = `${this.estimate.CustomerFirstName} ${this.estimate.CustomerLastName}`;
  
      if (this.portalEstimate?.IsPreview) {
        this.alertService.confirm(
          "Are you sure you want to mark this estimate as approved for your client?")
          .subscribe(async (response: any) => {
            if (response) {
              await this.apiCallSubmit(formValue);
            }
          });
      } else {
        await this.apiCallSubmit(formValue);
      }
    }
    
  }

  async apiCallSubmit(formValue: UpdatePortalEstimateDTO) {
    this.formSubmitBody.emit(formValue);
  }
}
